<script>
  import {mapGetters} from "vuex";
  /*
  * 配置面包屑流程:
  * 1 配置 config/index.js 下面的 breadcrumb
  * 2
  * */
  let styleCase = {
    case1: {display: 'block', padding: '5px 10%'},
    case2: {display: 'block', padding: '5px 20px'}
  }

  export default {
    computed: {
      ...mapGetters(['allBreads'])
    },
    methods: {
      loadBread(style, breadName, itemName) {
        let breadList = this.allBreads[breadName]
        if(!breadList) {
          this.$message.error(`${breadName}面包屑不存在！`)
        }
        let refineBreadList = []
        breadList.forEach(item => {
          if(item.name === itemName) {
            item.select = true
          } else {
            item.select = undefined
          }
          refineBreadList.push(item)
        })

        this.$store.commit("SET_BREAD_STYLE", style)
        this.$store.commit('SET_BREAD_LIST', refineBreadList)
      },

      /* 根据具体的面包屑，定制加载逻辑 */
      loadBreadWrapper(breadGroup, data) {
        let style = 0
        let selectName = ""

        if(breadGroup === "case.general") {
          /*
          * breadGroup: [case.general]
          * data: {
          *    step: 0, 1 [option]
          *    0 录入症状 1 录入诊断 2 审核通过 3 审核失败
          * }
          * */
          if(data.step !== undefined) {
            style = data.step === 0 ? styleCase.case1 : styleCase.case2
            selectName = data.step === 0 ? '基本信息': '症状采集'
          } else {
            style = data.style || styleCase.case2
            selectName = data.selectName
          }
        } else if(breadGroup === "case.config") {
          if(selectName === '疗效反馈'){
            style = styleCase.case1
          }
          if(data.step !== undefined) {
            style = data.step === 0 ? styleCase.case1 : styleCase.case2
            selectName = data.step === 0 ? '基本信息': '症状采集'
          } else {
            style = data.style || styleCase.case2
            selectName = data.selectName
          }
        }

        this.loadBread(
          style,
          breadGroup,
          selectName
        )
      },
      removeBread() {
        this.$store.commit("SET_BREAD_STYLE", {display: 'none'})
        this.$store.commit('SET_BREAD_LIST', [])
      }
    }
  }
</script>
